import { useEffect, useState } from "react";

import { coursesApi } from "api";

// Orders store a snapshot of the class in `metadata`, but early/failed
// orders have none. Fill those in from the class itself. Returns
// order => metadata, the order's own snapshot winning.
export default function useCourseInfo(list) {
  const [info, setInfo] = useState({});
  useEffect(() => {
    const missing = [...new Set(list.filter((o) => !o.metadata?.course_name || !o.metadata?.course_thumbnail).map((o) => o.course_id))];
    missing.forEach((id) =>
      coursesApi
        .details(id)
        .then((c) =>
          setInfo((prev) => ({
            ...prev,
            [id]: { course_name: c.name, course_thumbnail: c.thumbnail, course_price: c.price, course_level: c.level },
          }))
        )
        .catch(() => setInfo((prev) => ({ ...prev, [id]: { course_name: "Class no longer available" } })))
    );
  }, [list.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (order) => {
    const snapshot = Object.fromEntries(Object.entries(order.metadata ?? {}).filter(([, v]) => v != null && v !== ""));
    return { ...(info[order.course_id] ?? {}), ...snapshot };
  };
}
